"use client";

import React from "react";
import Image from "next/image";

const WhatAreAllOn6Implants: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          What Are All-on-6 Dental Implants?
        </h2>
        <div className="my-8 mx-auto max-w-2xl rounded-lg overflow-hidden shadow-lg">
          <Image
            src="/images/illustration-full-arch-dental-implants-with-six-titanium-posts-supporting-upper-replacement-teeth-and-gums.jpg"
            alt="illustration-full-arch-dental-implants-with-six-titanium-posts-supporting-upper-replacement-teeth-and-gums"
            width={800}
            height={600}
            className="w-full h-auto block"
            sizes="(max-width: 768px) 100vw, 672px"
          />
        </div>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Six implants per arch support a fixed bridge of prosthetic teeth.
          This replaces an entire upper or lower row without needing an
          individual implant for each tooth. The implants fuse with the
          jawbone, acting like natural tooth roots and providing a stable,
          long-lasting foundation.
        </p>
      </div>
    </section>
  );
};

export default WhatAreAllOn6Implants;
